export const TOGGLE_RESEARCH_MODE = 'TOGGLE_RESEARCH_MODE'

export function researchModeReducer (state = {value: false}, action) {
    switch (action.type){
        case TOGGLE_RESEARCH_MODE:
            return action.payload
        default: return state
    }
}